export function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function completeZeros(time) {
  if (time <= 9) return "0" + time;
  return time;
}

export function idyu_isAdmin(permission) {
  return permission >= 20;
}

export function idyu_hasPass(permission) {
  return permission >= 2;
}

export function idyu_hasSerenity(permission) {
  return permission >= 3;
}

export function idyuGetPassNameFromPermission(perm) {
  switch (perm) {
    case 0:
      return "Accès gratuit";
    case 1:
      return "Pass offert";
    case 2:
      return "Pass " + "<b><span class='black'>Idy</span><span class='pinklive'>live</span></b>";
    case 3:
      return "Pass <span class='serenite'>Sérénité</span>";
    case 10:
      return "Pass <strong>Modérateur</strong>";
    case 20:
      return "Pass <strong class='red'>Admin</strong>";
  }
  return "";
}

export function idyuGetPassName(store) {
  return idyuGetPassNameFromPermission(store.state.profile.permission);
}

export function idyuFormatDate(timeStamp) {
  const d = new Date(timeStamp);

  return completeZeros(d.getDate()) + "/" + completeZeros(d.getMonth() + 1) + "/" + d.getFullYear();
}

export function idyuFormatPrice(val, cur) {
  return val.toLocaleString("fr-FR", {
    style: "currency",
    currency: cur,
    currencyDisplay: "symbol"
  });
}

export function idyuMobileMode(store) {
  return store.state.windowWidth <= 745;
}

export function dateDiff(date1, date2) {
  var diff = {}; // Initialisation du retour
  var tmp = date2 - date1;

  tmp = Math.floor(tmp / 1000); // Nombre de secondes entre les 2 dates
  diff.sec = tmp % 60; // Extraction du nombre de secondes

  tmp = Math.floor((tmp - diff.sec) / 60); // Nombre de minutes (partie entière)
  diff.min = tmp % 60; // Extraction du nombre de minutes

  tmp = Math.floor((tmp - diff.min) / 60); // Nombre d'heures (entières)
  diff.hour = tmp % 24; // Extraction du nombre d'heures

  tmp = Math.floor((tmp - diff.hour) / 24); // Nombre de jours restants
  diff.day = tmp;

  return diff;
}

export function ellapsed(date) {
  let diff = dateDiff(date, Date.now());

  let res = "il y a ";
  if (diff.day != 0) {
    res += " " + diff.day + " jour";
    if (diff.day >= 2) res += "s";
  } else {
    if (diff.hour != 0) res += "  " + diff.hour + " heure";
    if (diff.hour >= 2) res += "s";
    if (diff.min != 0) {
      if (diff.hour != 0) res += " et ";
      res += "  " + diff.min + " minute";
      if (diff.min >= 2) res += "s";
    }
    if (diff.min == 0 && diff.hour == 0) {
      res += "quelques secondes";
    }
  }

  return res;
}

export function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function stripHtml(originalString) {
  if (originalString == null) {
    return "";
  }

  let res = originalString.replace(/<br ?[/>]?>/g, "\n");
  res = res.replace(/(<([^>]+)>)/gi, "");
  res = res.replace(/[&][^;]*;/g, "");
  return res.trim();
}

export function empty(desc) {
  if (!desc) {
    return true;
  }
  let stripped = stripHtml(desc);
  return stripped.length == 0;
}

export function bandeauModeration(profile) {
  /*
  if (
    profile &&
    profile.pictures.length == 0 &&
    empty(profile.shortDescription) &&
    empty(profile.shortDescriptionToValidate) &&
    empty(profile.longDescription) &&
    empty(profile.longDescriptionToValidate)
  ) {
    return 11;
  }
  */
  if (profile.validated == false) {
    return 12;
  }
  return 0;
}
